export default {
  header: ["Type", "Options"],
  body: [["--", ["--"]]]
};
